import styled from 'styled-components'

export const ConversationOrderSummaryDeliveryLineStyled = styled.div`
  padding: ${(props) =>
    `${props.theme.space.small} ${props.theme.space.medium}`};
  border-top: 1px solid ${(props) => props.theme.colors.content.border};
`
